<template>
	<article
		class="sanity-rich-text-component p-150 bg-color-greige module-radius-lg border-gray-20 text-align-left my-100"
	>
		<div v-if="title" class="subheading">{{ title }}</div>
		<RichTextComponent :blocks="body" class="callout-box-content body-md" />
	</article>
</template>

<script setup lang="ts">
import { SanityRichTextBlock, SanityRichTextCalloutBox } from 'types/sanity';
import { computed } from 'vue';
import { PortableTextComponentProps } from '@portabletext/vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';

type Props = PortableTextComponentProps<SanityRichTextCalloutBox>;
const props = defineProps<Props>();

const title = computed((): string => {
	return props.value.title ?? '';
});

const body = computed((): Array<SanityRichTextBlock> => {
	return props.value.body;
});
</script>

<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;

.border-gray-20 {
	border: 1px solid gray(20);
}

:deep(.callout-box-content figure.sanity-rich-text-component) {
	margin-top: 1rem;
}
</style>
